import type { V2ContentNode } from "../types";
import { isV2Group } from "../types";

export interface PanelEntry {
  /** The `panel` prop value — used as the DOM anchor id */
  panelId: string;
  /** The text shown in the sidebar */
  text: string;
  /** Nesting level in the content tree (for indentation) */
  level: number;
  /** Parent panel id (if nested) */
  parent?: string;
}

/**
 * Extract panel entries from content tree.
 * @param content - Content nodes to traverse
 * @returns Array of panel entries for sidebar
 */
export function extractPanelEntries(content: V2ContentNode[]): PanelEntry[] {
  const entries: PanelEntry[] = [];

  function walk(nodes: V2ContentNode[], level: number = 0, parent?: string) {
    for (const node of nodes) {
      if (!isV2Group(node)) continue;
      if (node.panel && node.label) {
        const label = node.label;
        const text = label?.panelText ?? label?.text ?? node.panel;
        entries.push({ panelId: node.panel, text, level, parent });
      }
      if (node.content) {
        const nextTargetParent = node.panel ? node.panel : parent;
        const nextLevel = node.panel ? level + 1 : level;
        walk(node.content, nextLevel, nextTargetParent);
      }
    }
  }

  walk(content);
  return entries;
}
